import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
@Pipe({
    name: 'planDurationInMonth'
})
export class PlanDurationInMonthPipe implements PipeTransform {

    regexpDuration = /^([0-9]+)\s?(days|months|years)$/;

    constructor(private readonly translateService: TranslateService) { }

    transform({ duration: durationPlan }: any) {
        const [fullmatch, amount, unit] = durationPlan.match(this.regexpDuration);
        const duration = moment.duration(+amount, unit as moment.unitOfTime.DurationConstructor);
        const numberInMonth = duration.asMonths();
        if (Number.isInteger(numberInMonth)) {
            return this.translateService.instant('PLAN_DURATION_IN_MONTH_PIPE_MONTHS', { number: numberInMonth });
        } else {
            return this.translateService.instant('PLAN_DURATION_PIPE_UNIT_DAYS', { number: duration.asDays() });
        }

    }
}
